import update from 'immutability-helper';
import {
  FETCH_ACTIVITY_LOG_PENDING,
  FETCH_ACTIVITY_LOG_SUCCEEDED,
  FETCH_ACTIVITY_LOG_FAILED,
} from '../constants/ActionTypes';

const initialState = {
  isLoading: false,
  logs: [],
};

export default function log(state = initialState, action = {}) {
  switch (action.type) {
    case FETCH_ACTIVITY_LOG_PENDING: {
      return update(state, { isLoading: { $set: true } });
    }
    case FETCH_ACTIVITY_LOG_SUCCEEDED: {
      return update(state, {
        isLoading: { $set: false },
        logs: { $set: action.data },
      });
    }
    case FETCH_ACTIVITY_LOG_FAILED: {
      return update(state, { isLoading: { $set: false } });
    }
    default: {
      return state;
    }
  }
}



// WEBPACK FOOTER //
// ./src/reducers/log.js